import { render } from "./CoverUpload.vue?vue&type=template&id=38f97300&scoped=true"
import script from "./CoverUpload.vue?vue&type=script&lang=js"
export * from "./CoverUpload.vue?vue&type=script&lang=js"

import "./CoverUpload.vue?vue&type=style&index=0&id=38f97300&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f97300"]])

export default __exports__